// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_landing_sign_in_title = /** @type {(inputs: {}) => string} */ () => {
	return `Sign in to MochiMemo`
};

const id_landing_sign_in_title = /** @type {(inputs: {}) => string} */ () => {
	return `Masuk ke MochiMemo`
};

const ja_landing_sign_in_title = /** @type {(inputs: {}) => string} */ () => {
	return `もちメモにサインインする`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "id" | "ja" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const landing_sign_in_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.landing_sign_in_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("landing_sign_in_title", locale)
	if (locale === "en") return en_landing_sign_in_title(inputs)
	if (locale === "id") return id_landing_sign_in_title(inputs)
	return ja_landing_sign_in_title(inputs)
};
export { landing_sign_in_title as "landing.sign_in_title" }